module.exports = __webpack_public_path__ + "static/CVLogo-0c0207ffb65eca3097dee8336914aaa1.png";